
import React, {useState, useEffect, useContext} from "react";
import { Form } from "react-bootstrap";
import Cookies from "js-cookie";
import { Box, Button, Divider, IconButton, Paper, TextField, Typography, Modal } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import LoadingModal from "../components/LoadingModal";
// import { GenerateDocument } from "../classes/GenerateDocx";
import { v4 as uuidv4 } from 'uuid';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import InlineEditor from '@ckeditor/ckeditor5-build-inline';
// import '../assets/css/style.css'
import axios from "axios";
import { ClickableChip } from "./components/ClickableChip";
import { separateArray } from "../../../controller/globalFunctions";
import { API } from "../../../controller/api";
import { useLocation, useNavigate } from "react-router-dom";
import { DrawerContext } from "../../../controller/context/DrawerWidthContext";
import { Circle } from "../components/Circle";
import DownloadDocxButton from "../components/DownloadDocx";

export const IqWriter = (props)=>{
    const user = JSON.parse(Cookies.get('user'));
    const userId = user.id;
    const location = useLocation();
    const state = location.state;
    const { drawerWidth } = useContext(DrawerContext);
const [loading, setLoading] = useState(true)
const [catArray, setCatArray] = useState([])
const [number, setNumber] = useState(0)
const [job, setJob] = useState('')
const [openModal, setOpenModal] = useState(false);
const [showDelete, setShowDelete] = useState(false);
const[newJobTitleInput, setNewJobTitleInput] = useState(true)
const[JobTitle, setJobTitle] = useState('')
const token = Cookies.get('token');
const categories = ['Adaptability','Ambition', 'Building Relationships', 'Caution', 'Communication', 'Conflict Management', 'Creativity', 'Customer Orientation','Decision Making', 'Delegation', 'Detail Orientation', 'Employee Development', 'Initiative', 'Integrity','Judgement', 'Leadership', 'Leading Change', 'Listening', 'Motivating Others', 'Negotiating', 'Organizational Awareness', 'Performance Management', 'Persuasion', 'Planning', 'Organizing', 'Presentations', 'Prioritization','Project Management', 'Problem Solving', 'Resilience', 'Sales', 'Self Improvement', 'Setting Goals', 'Strategic Thinking', 'Stress Management','Teamwork', 'Time Management','Values Diversity'] 
const [editorContent, setEditorContent] = useState('');
const [searchType, setSearchType] = useState('')
const navigate = useNavigate();


const saveDocument = ()=>{

    let object = {
        id:uuidv4(),
        jobTitle: job,
        content:editorContent
    }
    console.log(object)
}
const handleEditorChange = (event, editor) => {
    const data = editor.getData();
    setEditorContent(data);
  };

const AddRemoveCategory = (a)=>{

    if(catArray.includes(a)){
        let arr = catArray.filter(i=>{
            return (i !== a)
        })

        setCatArray(arr)
    } else {
        catArray.push(a)
    }
    console.log(catArray)

}
const handleBack = ()=>{
const check = window.confirm('If you choose to go back your questionnaire will not be saved. Are you sure you would like to do this?')
if(check){
 setSearchType('');
 setNewJobTitleInput(false)  
 setJobTitle('') 
setLoading(true);
setCatArray([]);
setNumber(0);
setJob('');

}
}

const createQuestionairre = ()=>{
console.log(job);
console.log(number);
console.log(catArray)
   setOpenModal(true)
        const getData = async ()=>{
         
            let htmlArr = [`<h3><b>Position: ${job}</b></h3>`]
             
            let dividedArray = separateArray(catArray)
          console.log(dividedArray)
           
            console.log(number)
            
            const prompt = `create a Javascript array of a interview questions for a ${job} using these categories ${JSON.stringify(catArray)} Please write ${JSON.stringify(number)} questions per category. Structure the array with a 'category' property with the category and a 'questions' property with an array of questions for that category. Then write it as a JSON string array and dont include the variable name. do not add any '\n'`
            
            dividedArray.map(async (i)=>{
                const newPrompt = `
            Act as an HR professional. Write interview questions for an ${job} using these categories: ${JSON.stringify(i)}

            Here is a an example of how the html should be returned: 

            <p style="font-size:18px;"><b>(category name)</b></p>
            <ul>
            <li>(Questions)</li>
            ...create ${number} questions per category
            </ul>
            

            `

            const postPrompt = `
            Act as an HR professional. Write interview questions for this job post: ${job} 
            
            use these categories: ${JSON.stringify(i)}

            Here is a an example of how the html should be returned: 

            <p style="font-size:18px;"><b>(category name)</b></p>
            <ul>
            <li>(Questions)</li>
            ...create ${number} questions per category
            </ul>
            

            `
                const response = await axios.post(`${API}/${state.route}/create-data-iqw`,{request: searchType ==='title'? newPrompt : postPrompt})
                if(response != 'error'){
                   console.log(response.data)
           
                     
                        let objects;
                        let jsonString = JSON.stringify(response.data)
                        try {
                         htmlArr.push(response.data)

                         if(htmlArr.length === dividedArray.length + 1){
                            setEditorContent(htmlArr.join(''))
                            setOpenModal(false)
                            setLoading(false)
                         }

                        } catch (error) {
                            setOpenModal(false)
                        console.error('Error parsing JSON response:', error);
                        alert('Something went wrong please try again.')
                        return;
                        }
                      
                    //     let arr = JSON.parse(response.text)
    
                       
                
                      
    
                     }
            })
       
                }
                getData()
    
    
}
if(loading) {
    return (
        <div style={{ overflowY: "auto", maxHeight: "100vh", paddingBottom: 100, marginTop: 80 }}>
      <Paper sx={{ p: 2, display: "flex", flexDirection: "column", marginLeft: drawerWidth === 0 ? 38 : 0 }}>

        <div style={{padding:'20px'}}>

            <Box>

            <Typography variant="button" sx={{fontSize:'16px'}}><b><Circle Title="1" Color="#9755EA"/>&nbsp; Job title:</b></Typography>
         
         <div style={{ marginTop:'10px'}}>
         <Typography sx={{marginTop:'10px'}} variant="subtitle2">Please enter the job title you would like questions for.</Typography>

            <Form.Control 
            placeholder="Job Title"
            onChange={(e)=> setJob(e.target.value)} 
            />
            </div>
            </Box>
            <hr></hr>
            <Typography variant="button" sx={{fontSize:'16px'}}><b><Circle Title="2" Color="#9755EA"/>&nbsp;  CATEGORIES:</b></Typography><br/>

            <Typography sx={{marginTop:'10px'}} variant="subtitle2">Select the categories you would like to create questions for.  <b>NOTE:</b> You can choose up to 8 categories.</Typography>
            <br></br>
            <Box  direction="row" sx={{textAlign:'center'}} spacing={1}>
             {categories.map((i,index)=>{
               return (
                <ClickableChip
                Key={index}
                 Label={i}
                 AddClick={()=>AddRemoveCategory(i)}/>

               )
             })}
            </Box>
            <hr></hr>
           
            <Box >
            <Typography variant="button" sx={{fontSize:'16px'}}><b><Circle Title="3" Color="#9755EA"/>&nbsp; Number of Questions:</b></Typography><br/>
            <Typography sx={{marginTop:'10px'}} variant="subtitle2">Select the amount of questions for each category you would like to create. After the questionnaire is create you will be able to delete unwanted questions. NOTE: You can create a up to 5 questions per category.</Typography>

            <br></br>
           <Box  direction="row" spacing={1}>
           <IconButton sx={{marginRight:'15px'}} iconStyle={{width:60, height:60}} onClick={()=>setNumber(number - 1)} ><RemoveIcon /></IconButton>
           <Typography style={{display:'inline', fontSize:'25px'}}><b>{number}</b></Typography>
            <IconButton sx={{marginLeft:'15px'}} onClick={number < 5 ?()=>setNumber(number + 1): ()=> alert('Five questions per category is the max ammount of questions that can be generated.')}><AddIcon/></IconButton>
            
            </Box>
            </Box>
            <br></br>
            <hr></hr>
            <div style={{textAlign:'right'}}>
            <Button sx={{marginTop:1, backgroundColor:'#9755EA'}} variant="contained" onClick={ job === '' || number === 0 || catArray.length < 1 ?()=>{ 
                console.log(job);
                let dividedArray = separateArray(catArray)
                console.log(dividedArray)
                window.alert('Please make sure you have filled in the necessary information and that your job title makes sense. You may also have selected more than 8 categories.') }: createQuestionairre}><b>Create Questionnaire</b></Button>
            </div> 
          <LoadingModal
          Open={openModal}
         Title="Questionnaire"
          />
       
        </div>
        </Paper>
        </div>
    )
} else {
    
    return (
        <div style={{ overflowY: "auto", maxHeight: "100vh", paddingBottom: 100, marginTop: 80 }}>


            <Box sx={{marginBottom:'10px',
         marginLeft: { xs: drawerWidth === 0 ? 38 : 0, sm: drawerWidth === 0 ? 38 : 0}

            }}>
            <Button variant="contained" onClick={handleBack}><ArrowBackIosNewIcon/> <b>BACK</b></Button>

            <DownloadDocxButton htmlContent={editorContent} docName={job} />

            <Button onClick={async ()=>{
                 let object = {
                    id:uuidv4(),
                    dateCreated: new Date(),
                    documentName: job,
                    content: editorContent
                }
               console.log(object)
               console.log(state.route)

           const response = await  axios.post(`${API}/${state.route}/save`,{userId: userId, object:object})
           if(response.data === "Saved"){
              navigate('/dc', {state:{route: 'iq-writer'}})
           } else {
            window.alert('Something went wrong. Please try again.')
           }
                
                }} sx={{marginLeft:'10px', float:'right', display:showDelete ? 'none':'inline'}}  variant="contained"><b>SAVE</b></Button>
                
            </Box>
<Box sx={{ marginTop:2, marginBottom:2,
          marginLeft: { xs: drawerWidth === 0 ? 38 : 0, sm: drawerWidth === 0 ? 38 : 0}
}}>
                <Typography variant="button" sx={{fontSize:'16px'}}><b><Circle Title="4" Color="#9755EA"/>&nbsp; Edit Document:</b> Click to edit the document.</Typography>

</Box>
<Paper sx={{ p: 2, display: "flex", flexDirection: "column",           marginLeft: { xs: drawerWidth === 0 ? 38 : 0, sm: drawerWidth === 0 ? 38 : 0}
 }}>
         
    <div style={{ height:'100%'}}>
    <div style={{ height:'100%'}}>
    <CKEditor
        editor={InlineEditor}
     
        data={editorContent}
        onChange={handleEditorChange}
      />
    
              
    </div>

              
    </div>
   
    </Paper>
    </div>
)

}
}